import { Link } from 'react-router-dom';

export default function Footer() {
  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Services' },
    { to: '/about', label: 'About ECS' },
    { to: '/contact', label: 'Contact Us' },
  ];

  const services = [
    'ISNetworld® Compliance',
    'Veriforce Management',
    'Avetta Qualification',
    'RAVS Plus Support',
    'Safety Training',
    'Injury Rate Reduction',
  ];

  return (
    <footer className="bg-white border-t border-[#E8E8E8]">

      {/* Platform logos strip */}
      <div className="w-full px-6 lg:px-14 py-14 border-b border-[#EBEBEB]">
        <p className="text-[#AAAAAA] text-[9px] tracking-[0.42em] uppercase font-semibold text-center mb-12">
          Platforms We Manage
        </p>
        <div className="flex flex-wrap items-center justify-center gap-10 lg:gap-16">

          {/* ISNetworld — logo sits directly on white */}
          <a
            href="http://isnetworld.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-4 cursor-pointer"
          >
            <div
              className="flex items-center justify-center border border-[#E8E8E8] rounded-lg transition-all duration-300 group-hover:border-[#C9A030]/50 group-hover:scale-[1.03]"
              style={{ width: '280px', height: '120px', padding: '24px 32px' }}
            >
              <img
                src="https://www.energycontractorservices.com/wp-content/uploads/2013/04/Screen-shot-2013-05-30-at-10.38.08-AM.png"
                alt="ISNetworld"
                style={{ maxHeight: '72px', maxWidth: '220px', width: 'auto', height: 'auto', objectFit: 'contain', display: 'block' }}
              />
            </div>
            <span className="text-[#AAAAAA] text-[9px] tracking-[0.28em] uppercase font-medium group-hover:text-[#C9A030] transition-colors">
              ISNetworld®
            </span>
          </a>

          <div className="hidden lg:block w-px h-24 bg-[#EBEBEB]" />

          {/* Veriforce — logo sits directly on white */}
          <a
            href="https://veriforce.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-4 cursor-pointer"
          >
            <div
              className="flex items-center justify-center border border-[#E8E8E8] rounded-lg transition-all duration-300 group-hover:border-[#C9A030]/50 group-hover:scale-[1.03]"
              style={{ width: '280px', height: '120px', padding: '24px 32px' }}
            >
              <img
                src="https://www.energycontractorservices.com/wp-content/uploads/2024/06/veri-2.png"
                alt="Veriforce"
                style={{ maxHeight: '72px', maxWidth: '220px', width: 'auto', height: 'auto', objectFit: 'contain', display: 'block' }}
              />
            </div>
            <span className="text-[#AAAAAA] text-[9px] tracking-[0.28em] uppercase font-medium group-hover:text-[#C9A030] transition-colors">
              Veriforce
            </span>
          </a>

          <div className="hidden lg:block w-px h-24 bg-[#EBEBEB]" />

          {/* Avetta — white logo needs dark background */}
          <a
            href="https://www.avetta.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-4 cursor-pointer"
          >
            <div
              className="flex items-center justify-center rounded-lg transition-all duration-300 group-hover:scale-[1.03] group-hover:ring-2 group-hover:ring-[#C9A030]/40"
              style={{ width: '280px', height: '120px', padding: '24px 32px', backgroundColor: '#0A2540' }}
            >
              <img
                src="https://www.energycontractorservices.com/wp-content/uploads/2012/06/avetta-logo-white-768x265-300x104.png"
                alt="Avetta"
                style={{ maxHeight: '72px', maxWidth: '220px', width: 'auto', height: 'auto', objectFit: 'contain', display: 'block' }}
              />
            </div>
            <span className="text-[#AAAAAA] text-[9px] tracking-[0.28em] uppercase font-medium group-hover:text-[#C9A030] transition-colors">
              Avetta
            </span>
          </a>

        </div>
      </div>

      {/* Main footer grid */}
      <div className="w-full px-6 lg:px-14 pt-14 pb-12 grid grid-cols-1 lg:grid-cols-4 gap-12 border-b border-[#EBEBEB]">

        {/* Brand column — logo sits naturally on white */}
        <div className="lg:col-span-1">
          <div className="mb-5">
            <img
              src="https://www.energycontractorservices.com/wp-content/uploads/2012/06/ecs100.jpg"
              alt="Energy Contractor Services"
              className="h-12 w-auto object-contain"
            />
          </div>
          <p className="text-[#888] text-sm font-light leading-relaxed mb-6 max-w-56">
            Expert ISNetworld®, Veriforce, and Avetta compliance management for energy contractors nationwide.
          </p>
          <a
            href="tel:4054081117"
            className="inline-flex items-center gap-2.5 text-[#C9A030] font-semibold text-base tracking-wide cursor-pointer hover:text-[#B8901F] transition-colors"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base" />
            </span>
            405-408-1117
          </a>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="text-[#1A1A1A] font-semibold text-xs tracking-[0.28em] uppercase mb-6">
            <a href="#navigation">Navigation</a>
          </h4>
          <ul className="space-y-3">
            {navLinks.map(({ to, label }) => (
              <li key={to}>
                <Link
                  to={to}
                  className="text-[#888] text-sm font-light hover:text-[#C9A030] transition-colors cursor-pointer"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-[#1A1A1A] font-semibold text-xs tracking-[0.28em] uppercase mb-6">
            <a href="#services">Services</a>
          </h4>
          <ul className="space-y-3">
            {services.map((s) => (
              <li key={s}>
                <Link
                  to="/services"
                  className="text-[#888] text-sm font-light hover:text-[#C9A030] transition-colors cursor-pointer"
                >
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact CTA */}
        <div>
          <h4 className="text-[#1A1A1A] font-semibold text-xs tracking-[0.28em] uppercase mb-6">
            <a href="#contact">Get Compliant</a>
          </h4>
          <p className="text-[#888] text-sm font-light leading-relaxed mb-5">
            Ready to achieve 100% compliance on ISNetworld, Veriforce, or Avetta? Talk to a specialist today.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#C9A030] text-white px-5 py-2.5 text-[11px] font-bold tracking-[0.2em] uppercase whitespace-nowrap cursor-pointer hover:bg-[#B8901F] transition-colors"
          >
            Start Today
          </Link>
          <div className="mt-5">
            <a
              href="tel:4054081117"
              className="flex items-center gap-2 text-[#888] text-sm hover:text-[#C9A030] transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm" />
              </span>
              405-408-1117
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="w-full px-6 lg:px-14 py-5 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-3">
        <p className="text-[#BBBBBB] text-xs font-light">
          Copyright &copy; 2026 Energy Contractor Services. All Rights Reserved.
        </p>
        <p className="text-[#BBBBBB] text-[11px] font-light max-w-xl leading-relaxed lg:text-right">
          ECS is in no way endorsed, sponsored, approved by, or otherwise affiliated with ISNetworld®.
          &ldquo;ISNetworld®&rdquo; and &ldquo;RAVS®&rdquo; are registered trademarks of ISN Software Corporation.
        </p>
      </div>
    </footer>
  );
}
